<template>
  <div>
    <div class="hero section-type-b presentation">
      <div class="container pb-10">
          <div class="row section-type-c presentation-inner-padding-top2 ">
              <div class="col-12 ">
                  <div class="article-caption mw-100 bground-config-clean"  :style="{ backgroundImage: `url('${articulo.portada}')` }" style="margin-top: 54px;"></div>
                  <div class="bg-light p-4">
                      <h1 class="mb-8 mt-4">
                        {{ articulo.titulo }}
                      </h1>
                      <small>{{ articulo.descripcion }}</small>
                      <div class="d-flex mt-4 mb-32">
                        <img src="@/assets/images/customers/5.jpg" class="w-100 rounded-circle" :style="{ maxWidth: '80px', height: '80px' }">
                        <p class="mb-8 p-2">
                            <strong>AUTOR</strong>
                            <br> Autor
                        </p>
                      </div>
                      <h4>Contenido</h4>
                      <p>{{articulo.contenido}}</p>
                  </div>
              </div>
          </div>
          <div class="mt-5">
            <h3 class="text-center text-light mb-32">Otros artículos que podrían interesarte</h3>
          </div>
          <div class="row section-type-c">
            <BlogEntrance v-bind:key="bl.idArticulo" v-for="bl in blog"
                          :portada=bl.portada
                          :titulo=bl.titulo
                          :descripcion=bl.descripcion
                          :contenido=bl.contenido
                          :id=bl.idArticulo
                          :fecha=bl.descripcion
            ></BlogEntrance>
          </div>
      </div>
      <br/>
      <br/>
      <br/>
    </div>

  </div>
</template>

<script>
import BlogEntrance from '@/components/BlogEntrance'
export default {
  name: 'Article',
  components: {
    BlogEntrance
  },
  data () {
    return {
      articulo: {},
      blog: [],
      articleHero: require('@/assets/images/pexels-vlad-alexandru-popa-1402787.jpg')
    }
  },
  async mounted () {
    const id = this.$route.params.id
    this.$http.get(`${this.API_URL}/web/blogs/${id}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      console.log(res)
      this.articulo = res.data.data
    })

    const articulos = await this.$http.get(`${this.API_URL}/web/blogs/all?page=1&limit=3${this.API_URL}`)
    this.blog = articulos.data.data.elementos
  }
}
</script>

<style scoped>

</style>
